import * as angularAnimations from "@angular/animations";
import * as angularAnimationsBrowser from "@angular/animations/browser";

// global glue variable for externals
if (window["ng"] == null) window["ng"] = <any>{};

window["ng"].animations = angularAnimations;
window["ng"].animations.browser = angularAnimationsBrowser;

export { angularAnimations, angularAnimationsBrowser };
